import {
  FEC_IMPORT_FAILED_POLLING_MAX_INTERVAL_MS,
  FEC_IMPORT_FAILED_POLLING_STEPS,
} from '../constants/fecImportPolling'

/** How long to wait before reading the list again, given how long an import has been failed. */
export const getFecImportFailedPollingIntervalMs = (elapsedMs: number): number =>
  FEC_IMPORT_FAILED_POLLING_STEPS.find(({ untilMs }) => elapsedMs < untilMs)?.intervalMs ??
  FEC_IMPORT_FAILED_POLLING_MAX_INTERVAL_MS
